import type { DomainMapper } from '../types';

const us: DomainMapper = {
  countryCode: 'us',
  currency: 'USD',
  dataAreaId: 'us40',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/US.svg',
  languagePrimary: true,
  locale: 'en-us',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  productBasePath: 'produkt',
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-us.xml',
  storyblokBasePath: 'us',
  url: 'https://localhost:3011/us',
  algoliaIndex: 'b2b-us-en-US-products',
  algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
  algoliaIndexPages: 'content_',
  //applicationId: 1357, // prod
  applicationId: 1353, // stage
  subFolder: true,
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    // applicationId: 1357, // prod
    applicationId: 1353, // stage
    algoliaIndex: 'b2b-us-en-US-products',
    algoliaIndexAutocomplete: 'b2b-us-en-US-products_query_suggestions',
    displayIncVat: false,
    default: true,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-us.xml',
  },
  b2c: {
    enabled: true,
    productBasePath: 'product',
    storyblokBasePath: '',
    algoliaIndex: 'b2c-us-en-US-products',
    algoliaIndexAutocomplete: 'b2c-us-en-US-products_query_suggestions',
    applicationId: 1467,
    displayIncVat: true,
    default: false,
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-us-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
    onlyAllowCustomerEditAddressesForSamples: true,
    disableShipToConsumer: false,
  },
  measurement: 'imperial',
  showNonPublicProducts: true,
} as DomainMapper;

export default us;
